import React, { useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";

const RichTextEditor = ({ value, onChange, disabled, editorRef }) => {
  const localRef = useRef(null);
  const resolvedRef = editorRef || localRef;

  useEffect(() => {
    if (!resolvedRef.current) return;
    const nextValue = value || "";
    const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(nextValue);
    if (looksLikeHtml) {
      if (resolvedRef.current.innerHTML !== nextValue) {
        resolvedRef.current.innerHTML = nextValue;
      }
    } else if (resolvedRef.current.innerText !== nextValue) {
      resolvedRef.current.innerText = nextValue;
    }
  }, [value, resolvedRef]);

  const applyFormat = (command, commandValue = null) => {
    if (!resolvedRef.current || disabled) return;
    resolvedRef.current.focus();
    document.execCommand(command, false, commandValue);
    onChange(resolvedRef.current.innerHTML || "");
  };

  const handleInput = () => {
    if (!resolvedRef.current || disabled) return;
    onChange(resolvedRef.current.innerHTML || "");
  };

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          p: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.default",
        }}
      >
        <Button
          size="small"
          variant="outlined"
          onClick={() => applyFormat("bold")}
          disabled={disabled}
        >
          Fett
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={() => applyFormat("italic")}
          disabled={disabled}
        >
          Kursiv
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={() => applyFormat("underline")}
          disabled={disabled}
        >
          Unterstrichen
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={() => applyFormat("insertUnorderedList")}
          disabled={disabled}
        >
          Liste
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={() => applyFormat("insertOrderedList")}
          disabled={disabled}
        >
          Nummeriert
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={() => applyFormat("insertHTML", "<br>")}
          disabled={disabled}
        >
          Zeilenumbruch
        </Button>
      </Box>
      <Box
        ref={resolvedRef}
        contentEditable={!disabled}
        suppressContentEditableWarning
        onInput={handleInput}
        onBlur={handleInput}
        sx={{
          minHeight: 180,
          p: 2,
          outline: "none",
          backgroundColor: disabled ? "action.disabledBackground" : "inherit",
        }}
      />
    </Box>
  );
};

export default RichTextEditor;
